export default __webpack_public_path__ + "static/media/tbg-logo.6390a849.png";